import { useEffect } from "react";
import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { LogoMark } from "@/components/LogoMark";

export const Preloader = ({ onComplete }) => {
    const progress = useMotionValue(0);
    const counter = useTransform(progress, (v) =>
        String(Math.round(v)).padStart(3, "0"),
    );
    const barScale = useTransform(progress, [0, 100], [0, 1]);

    useEffect(() => {
        const controls = animate(progress, 100, {
            duration: 2.2,
            ease: [0.65, 0, 0.35, 1],
            onComplete: () => setTimeout(onComplete, 300),
        });
        return () => controls.stop();
    }, [onComplete, progress]);

    return (
        <motion.div
            data-testid="preloader"
            exit={{ y: "-100%" }}
            transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
            className="fixed inset-0 z-[100] flex flex-col justify-between overflow-hidden bg-[#050505] px-6 py-8 md:px-12 md:py-10"
        >
            <div className="flex items-start justify-between">
                <p className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-zinc-500">
                    [ Loading Systems ]
                </p>
                <p className="font-mono-x text-[11px] uppercase tracking-[0.25em] text-zinc-500">
                    Est. 2019
                </p>
            </div>

            <div className="pointer-events-none absolute inset-0 flex flex-col items-center justify-center gap-8">
                <LogoMark size={56} animated className="text-white" />
                <motion.p
                    data-testid="preloader-logo"
                    initial={{ opacity: 0, y: 28, filter: "blur(10px)" }}
                    animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                    transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 0.15 }}
                    className="font-display text-6xl font-black tracking-tighter text-white md:text-8xl"
                >
                    RaRe<span className="align-super text-[0.35em] text-white/40">®</span>
                </motion.p>
            </div>

            <div className="flex items-end justify-between gap-6">
                <p className="font-mono-x mb-3 text-[11px] uppercase leading-relaxed tracking-[0.25em] text-zinc-500 md:mb-6">
                    Idea in.
                    <br />
                    Business out.
                </p>
                <motion.span
                    data-testid="preloader-counter"
                    className="font-display block text-[26vw] font-black leading-[0.85] tracking-tighter text-white md:text-[15vw]"
                >
                    {counter}
                </motion.span>
            </div>

            <motion.div
                style={{ scaleX: barScale }}
                className="absolute bottom-0 left-0 h-[2px] w-full origin-left bg-white"
            />
        </motion.div>
    );
};
